"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function renderPropType(whitelistedProps) {
    var noExtraneous = function (_a, propName, componentName) {
        var props = __rest(_a, []);
        if (typeof props[propName] === 'function') {
            delete props[propName];
            whitelistedProps.forEach(function (name) {
                delete props[name];
            });
            var extraPropNames = Object.keys(props);
            if (extraPropNames.length) {
                var joined = extraPropNames.map(function (pn) { return "`" + pn + "`"; }).join(', ');
                return new Error("Received extraneous props: " + joined + " in component `" + componentName + "`. "
                    + 'You should pass extra props directly to your component when using render prop.');
            }
        }
        return null;
    };
    return noExtraneous;
}
exports.default = renderPropType;
